// generate a slice file
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import {
  IMerchantInfoResponse,
  BranchInfoResponse,
  IOnboardingMerchantInfoResponse
} from "../../types/onboarding-system/onboarding.response.dto";

export interface IOnboardingSystemState {
  merchant : IMerchantInfoResponse | null
  branch: BranchInfoResponse | null

  // client side state
  themeCategoryId: string
}

export const OnboardingSystemSlice = createSlice({
  name: 'onboardingSystem',
  initialState: {
    merchant: null,
    branch: null,
    themeCategoryId: '',
  } as IOnboardingSystemState,
  reducers: {
    setOnboardingSystemInfo: (state, action: PayloadAction<IOnboardingMerchantInfoResponse>) => {
      state.merchant = action.payload.merchant;
      state.branch = action.payload.branch;
    },
  },
})

export const {setOnboardingSystemInfo} = OnboardingSystemSlice.actions;
export default OnboardingSystemSlice.reducer;

export const selectOnboardMerchantInformation = (state: RootState) =>
  state.onboardingSystem.merchant;
export const selectOnboardBranchInformation = (state: RootState) =>
  state.onboardingSystem.branch;
